module.exports = __webpack_public_path__ + "img/green-rectangle-table-10.f9aa2029.png";